import { DEFAULT_PLAN_FEATURES } from '@/lib/plans/default-features';
import { Check } from 'lucide-react';

interface DefaultFeaturesSectionProps {
  variant?: 'default' | 'compact';
}

export function DefaultFeaturesSection({ variant = 'default' }: DefaultFeaturesSectionProps) {
  if (variant === 'compact') {
    return (
      <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-4 border border-primary/10">
        <h4 className="text-sm font-semibold mb-3 flex items-center gap-2">
          <Check className="h-4 w-4 text-primary" />
          Recursos Incluídos
        </h4>
        <div className="grid grid-cols-2 gap-2">
          {DEFAULT_PLAN_FEATURES.map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <div key={idx} className="flex items-center gap-2 text-xs">
                <Icon className="h-3 w-3 text-primary" />
                <span className="text-muted-foreground">{feature.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-4 border border-primary/10">
      <h4 className="text-sm font-semibold mb-3 flex items-center gap-2">
        <Check className="h-4 w-4 text-primary" />
        Recursos Incluídos em Todos os Planos
      </h4>
      <div className="space-y-2">
        {DEFAULT_PLAN_FEATURES.map((feature, idx) => {
          const Icon = feature.icon;
          return (
            <div key={idx} className="flex items-start gap-2">
              <Icon className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
              <div>
                <div className="text-sm font-medium">{feature.label}</div>
                <div className="text-xs text-muted-foreground">{feature.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
